import React, { Component } from 'react';
import PathContext from "../../context/path";
import styles from './Test.module.sass';
import Socials from '../../components/Socials';
import {
	Link
} from "react-router-dom";
class Test extends Component {
	state = {
		init: false,
		stage: 0,
		true_answer: 0,
		count: 0
	}
	static contextType = PathContext;
	path = this.context;
	data = [
		{
			"question": "How do you find out if a person has HIV or not?",
			"answers": [
				"Only by testing for HIV antibodies",
				"There will be external signs and symptoms of the illness",
				"By asking at an HIV center"
			],
			"text": ["The presence of an HIV infection in the body is impossible to detect by assessing a person’s external appearance or how they feel. A test for HIV antibodies is needed. You can carry out that test yourself with an express test, at the HIV.CENTER or at your local health clinic. The results are confidential and are not reported anywhere."],
			"img": "/img/gifs/2-pers_question.gif",
			"true_answer": 0,
			"var_answer": false
		},
		{
			"question": "Who do you think can get HIV?",
			"answers": [
				"Only people in minority groups can get HIV",
				"HIV doesn’t choose its victims, it’s a virus",
				"For the most part, it’s drug users who are HIV positive"
			],
			"text": ["Today, HIV is so widespread that absolutely everyone is in the risk group, irrespective of their interests, sexual preferences or the amount of money they have on their bank card."],
			"img": "/img/gifs/2photos.gif",
			"true_answer": 1,
			"var_answer": false
		},
		{
			"question": "At what age do people most frequently find out that they are HIV positive?",
			"answers": [
				"18–25 years of age",
				"25–29 years of age",
				"30–49 years of age"
			],
			"text": ["HIV long ago stopped being a problem that is confined to youth, an age where people try injecting drugs and engage in sexual practices without restraint in all their variety. Today, HIV is a problem for all adults. 71% of new HIV cases are identified in the 30-49 years of age bracket."],
			"img": "/img/gifs/age.gif",
			"true_answer": 2,
			"var_answer": false
		},
		{
			"question": "Which factor represents the greatest danger for the transmission of HIV?",
			"answers": [
				"Homosexual contacts",
				"Heterosexual contacts",
				"Intravenous injections "
			],
			"text": ["At present in Russia, the most frequent way for HIV for to be transmitted is through unprotected heterosexual sex. 65% of the total number of infections was through unprotected sex."],
			"img": "/img/gifs/vesy.gif",
			"true_answer": 1,
			"var_answer": false
		},
		{
			"question": "Which kind of contact entirely avoids the risk of transmitting HIV?",
			"answers": [
				"Oral sex",
				"Blood transfusion.",
				"Through the use of everyday items"
			],
			"text": [["There is a risk in oral sex if there are serious wounds with blood flow through which the virus can get into your organism. Cases where people contract HIV through medical mistakes are very rare. Such cases in Russia are exceptional.", " Everyday contacts are not a risk. The virus can’t exist outside of a body, and it simply doesn’t exist in saliva or on the skin."], ["Cases where people contract HIV through medical mistakes are very rare. Such cases in Russia are exceptional. There is a risk in oral sex if there are serious wounds with blood flow through which the virus can get into your organism.", "Everyday contacts are not a risk. The virus can’t exist outside of a body, and it simply doesn’t exist in saliva or on the skin."], ["Everyday contacts are not a risk. The virus can’t exist outside of a body, and it simply doesn’t exist in saliva or on the skin.", "There is a risk in oral sex if there are serious wounds with blood flow through which the virus can get into your organism. Cases where people contract HIV through medical mistakes are very rare. Such cases in Russia are exceptional."]],
			"img": "/img/gifs/arms.gif",
			"true_answer": 2,
			"var_answer": true
		},
		{
			"question": "How long after a risky contact should you take an HIV test to get the most accurate result?",
			"answers": [
				"Within a week",
				"After a month",
				"After 3 months"
			],
			"text": ["In order for the test to be sufficiently accurate, about 3 months should have passed since the risky contact. Over the first 3 months HIV antibodies are only forming, and the test may give an inaccurate result."],
			"img": "/img/gifs/timer.gif",
			"true_answer": 2,
			"var_answer": false
		},
		{
			"question": "How can you make sure you and your partner are safe?",
			"answers": [
				"Get tested for HIV and find out your HIV status",
				"Get tested for HIV and find out your HIV status",
				"Get tested for HIV and find out your HIV status"
			],
			"text": ["We now have a fairly large number of ways to be tested, ranging from laboratory tests to express tests that can be carried out at home. Whichever option you choose, you’ll be on the right track in your sexual relations and where healthcare is concerned. Don’t be scared and don’t be plagued by doubts. Knowing your HIV status today is part of your commitment to your future."],
			"img": "/img/gifs/wit.gif",
			"true_answer": -1,
			"var_answer": false
		}
	];
	page = null;

	popup = null;
	componentDidMount() {
		window.scrollTo(0, 0);
		setTimeout(()=>{
			this.data.forEach((item) => {
				const img = new Image();
				img.src = `${this.path}${item.img}`;
			});
		}, 800);
		this.initTest();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		};
	}
	initTest() {
		this.setState({
			stage: 0,
			true_answer: 0,
			count: 0
		});

		this.setPage(-1);
	}
	setPage(number) {

		this.popup = null;

		this.setState({
			stage: number
		}, () => {
			if (number < 0) {
				this.page = this.setMainPage();
				this.setState({});
			} else if (number < this.data.length) {
				this.page = this.setTestPage(number);
				this.setState({});
			} else {
				this.page = this.setFinalPage();
				this.setState({});
			}
		});
	}
	setMainPage() {
		return <>
		<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.main_wrap}>
				
				<h1 className={styles.main_title}>
				What do you know about HIV infection?
				</h1>

				<div className={styles.main_desc}>Test your knowledge</div>
				<div className={styles.main_img}>
					<img src={`${this.path}/img/gifs/question.gif`} alt="" />
				</div>
				<div className={styles.btn} onClick={this.setPage.bind(this, 0)}>START</div>
			</div>
		</>

	}
	setTestPage(number) {
		let btn = null;
		btn = this.data[number].answers.map((item, index) => {
			return <div key={index} className={styles.btn_test} onClick={this.setAnswer.bind(this, index)}>{item}</div>
		});

		this.setState({
			true_answer: this.data[number].true_answer
		});
		return <>
		<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.header}>
				
				<div className={styles.title}>{this.data[number].question}</div>
				<div className={styles.counter}>{`${number + 1} | ${this.data.length}`}</div>
			</div>
			<div className={styles.img}>
				<img key={number} src={`${this.path}${this.data[this.state.stage].img}`} alt="" />
			</div>
			<div className={styles.btns}>
				{btn}
			</div>
		</>

	}
	setFinalPage() {
		let title = 'You need to fill in the gaps.';
		let text = 'Now you know more about the virus and understand why your HIV status is so important. And mistakes are just good grounds to improve your knowledge.';
		if (this.state.count === this.data.length) {
			title = 'Excellent result!';
			text = 'Now you know more about the virus and understand why your HIV status is so important.';
		}
		return <>
				<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.final_header}>
				
				<div className={styles.final_counter}>{`${this.state.count} | ${this.data.length}`}</div>
				<div className={styles.final_title}>{title}</div>
			</div>
			<div className={styles.final_text}>{text}</div>
			<div className={styles.socials}>
				<Socials />
			</div>
			<div className={styles.final_btns}>
				<div className={`${styles.btn} ${styles.btn_trans}`} onClick={this.initTest.bind(this)}>Retake the Test</div>
				<Link to='/' className={styles.btn}>Go to Project</Link>
			</div>
		</>

	}
	setAnswer(number) {
		let bool = true;
		if (this.state.true_answer === number || this.state.true_answer < 0) {
			bool = true;
			this.setState({
				count: this.state.count + 1
			});
		} else {
			bool = false;
		}
		this.showPopup(bool, number);

		this.setState({});
	}
	showPopup(bool, number) {
		let style = `${styles.popup}`;
		let title = 'Correct!';
		let next = 'Find out the result';

		if (this.state.stage < this.data.length - 1) {
			next = 'Next';
		}
		if (bool === false) {
			style = `${styles.popup} ${styles.popup_false}`;
			title = 'Incorrect';
		}
		let text = this.data[this.state.stage].text[0];
		if (this.data[this.state.stage].var_answer === true) {
			text = this.data[this.state.stage].text[number].map((item, index) => {
				return <p key={index}>{item}</p>
			});
		}
		this.popup = <div className={style}>
			<div className={styles.popup_overlay}></div>
			<div className={styles.popup_body}>
				<div className={styles.popup_title}>{title}</div>
				<div className={styles.popup_text}>{text}</div>
				<div className={styles.popup_btn} onClick={this.setPage.bind(this, this.state.stage + 1)}>{next}</div>
			</div>
		</div>
	}
	render() {


		return <div className={`${styles.wrap} ${styles[`wrap_${this.state.stage}`]}`}>
			<div className={styles.bg}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-bg-desktop.png`} />

					<img src={`${this.path}/img/test-bg.png`} alt="" />
				</picture>
			</div>
			{this.popup}
			<div className={styles.page} >
				{this.page}
			</div>
		</div>;
	}
}

export default Test;
